import { axiosInstance } from "../axios";
import { base_url, product_apis } from "../ApiConst";
import axios from "axios";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
// import {Token} from "../Token";
// import { base_url } from "../ApiConst";
// import axios from "axios";

export const Product_list = async (
  subId,
  userLatitude,
  userLongitude,
  userPincode,
  limit,
  page
) => {
  const data = JSON.stringify({
    lat: userLatitude,
    long: userLongitude,
    pincode: userPincode,
    sub_category: subId,
  });

  // const config = {
  //   method: 'post',
  //   maxBodyLength: Infinity,
  //   url: `${base_url}api/v0/product/home_product_list/?page=${page}&limit=${limit}`,
  //   headers: {
  //     Authorization: Token, // Replace Token with your actual token variable
  //     'Content-Type': 'application/json',
  //   },
  //   data: data, // Pass data as the request body
  // };

  try {
    // const response = await axios.request(config);
    const response = await axiosInstance.post(
      product_apis.home_product_list(page, limit),
      data
    );

    return response;
  } catch (error) {
    throw new Error(error);
  }
};

// search product api
export const Search_Products = async (
  isSearch,
  searchText,
  userLatitude,
  userLongitude,
  userPincode
) => {
  // const token = "9i8h7g6f-5e4d-3c2b-1a0j-dcba098765fe";
  // return await axios.get(
  //   `${base_url}api/v0/dashboard/search/products/?is_search=${isSearch}`,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: Token,
  //     },
  //     params: {
  //       search_text: searchText,
  //       lat: userLatitude,
  //       long: userLongitude,
  //       pincode: userPincode,
  //     },
  //   }
  // );
  return await axiosInstance.get(product_apis.search_products(isSearch), {
    params: {
      search_text: searchText,
      lat: userLatitude,
      long: userLongitude,
      pincode: userPincode,
    },
  });
};

// export const Add_Product = async (
//   data,
//   productImage,
//   additionalImage1,
//   additionalImage2
// ) => {
//   let params = new FormData();

// Append form data fields to the FormData object
// console.log(productImage, "images------------>");
// params.append("product_name", data?.productName ?? null);
// params.append("product_description", data?.description ?? null);
// productImage && params.append("product_image", productImage);
// additionalImage1 && params.append("additional_image_1", additionalImage1); // additional_image_1
// additionalImage2 && params.append("additional_image_2", additionalImage2); // additional_image_2
// params.append("product_subcategory", data?.category);
// params.append("pieces", 0);
// params.append("available", data?.inventory);
// params.append("unit_measure", data?.unitOfMeasure);
// params.append("weight", data?.variants ?? null);
// data?.minQuantity ? parseInt(data?.minQuantity) : 0
// params.append("price", parseInt(data?.priceInNepali));
// params.append("usd_price", parseInt(data?.price));
// params.append("nepali_name", data?.productNameInNepali ?? null);
// params.append("nepali_description", data?.descriptionInNepali ?? null);

// params.append("minimum_qty", parseInt(data?.minQuantity ?? null));
// params.append("maximum_qty", data?.maxQuantity ?? null);

// if (data?.minQuantity !== undefined && data?.minQuantity !== null && data?.minQuantity !== "") {
//   params.append("minimum_qty", parseInt(data?.minQuantity));
// }

// if (data?.maxQuantity !== undefined && data?.maxQuantity !== null && data?.maxQuantity !== "") {
//   params.append("maximum_qty", parseInt(data?.maxQuantity));
// }
// params.append("sku", data?.sku ?? null);
// params.append("brand", data?.brand ?? null);
// params.append("threshold_limit", data?.threshold_limit ?? null);

//threshold_limit
// data?.variants && params.append("variants", [data?.variants]);
// params.append("language_data_list", []);
// let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);

// return await axios.post(`${base_url}api/v0/product/add/`, params, {
//   headers: {
//     "Content-Type": "multipart/form-data",
//     Authorization: "Token " + userToken1,
//   },
// });
// return await axiosInstance.post(product_apis.add_product, params, {
//   headers: {
//     "Content-Type": "multipart/form-data",
//     Authorization: "Token " + userToken1,
//   },
// });
//   return await axiosInstance.post(product_apis.add_product, params, { useUserToken: true, contentType: "multipart/form-data" });
// };

// export const Edit_Product = async (
//   userToken,
//   data,
//   productImage,
//   product_id,
//   additionalImage1,
//   additionalImage2
// ) => {
//   let params = new FormData();
//   params.append("product_name", data.productName);
//   params.append("product_description", data.description);
//   productImage && params.append("product_image", productImage);
//   additionalImage1 && params.append("additional_image_1", additionalImage1);
//   additionalImage2 && params.append("additional_image_2", additionalImage2);
//   params.append("product_subcategory", parseInt(data.category));
//   params.append("pieces", parseInt(data.minQuantity));
//   params.append("available", parseInt(data.inventory));
//   params.append("unit_measure", data.unitOfMeasure);
//   params.append("weight", parseInt(data.variants));
//   params.append("weight", parseInt(0));
//   params.append("height", parseInt(0));
//   params.append("price", parseInt(data.priceInNepali));
//   params.append("usd_price", parseInt(data.price));
//   params.append("variants", data.variants);
//   params.append("nepali_name", data.productNameInNepali);
//   params.append("nepali_description", data.descriptionInNepali);
//   params.append("minimum_qty", parseInt(data?.minQuantity));
//   params.append("maximum_qty", data?.maxQuantity ?? null);
//   params.append("sku", data?.sku ?? null);
//   params.append("brand", data?.brand ?? null);
//   params.append("threshold_limit", data?.threshold_limit ?? null);

// params.append("variants", ["L"]);
// params.append("language_data_list", []);
// "is_active" = "True",
// "nepali_name":"Nepali String",
// "nepali_description":"Nepali description"

// return await axios.put(
//   `${base_url}api/v0/product/update_product/${product_id}/`,
//   params,
//   {
//     headers: {
//       "Content-Type": "multipart/form-data",
//       Authorization: "Token " + userToken,
//     },
//   }
// );
//   return await axiosInstance.put(product_apis.update_product(product_id), params, { useUserToken: true, contentType: "multipart/form-data" });
// };

// product details api
export const Product_Details = async (
  product_id,
  userLatitude,
  userLongitude,
  userPincode
) => {
  // return await axios.get(
  //   `${base_url}api/v0/product/product_deatils/${product_id}/`,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: Token,
  //     },
  //     params: {
  //       lat: userLatitude,
  //       long: userLongitude,
  //       pincode: userPincode,
  //     },
  //   }
  // );
  return await axiosInstance.get(product_apis.product_details(product_id), {
    params: {
      lat: userLatitude,
      long: userLongitude,
      pincode: userPincode,
    },
  });
};

export const Single_Product_Details = async (
  identifier,
  userLatitude,
  userLongitude,
  userPincode
) => {
  // return await axios.get(
  //   `${base_url}api/v0/product/product_deatils/${identifier}/`,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: Token,
  //     },
  //     params: {
  //       lat: userLatitude,
  //       long: userLongitude,
  //       pincode: userPincode,
  //     },
  //   }
  // );
  return await axiosInstance.get(
    product_apis.single_product_details(identifier),
    {
      params: {
        lat: userLatitude,
        long: userLongitude,
        pincode: userPincode,
      },
    }
  );
};

export const getOutOfStockProductList = async (payload) => {
  // console.log(order,"order------------>")

  // return await axios.post(
  //   `${base_url}api/v0/product/check-zero-product/?all=true`,
  //   payload,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: "9i8h7g6f-5e4d-3c2b-1a0j-dcba098765fe",
  //     },
  //   }
  // );
  return await axiosInstance.post(
    product_apis.getOutOfStockProductList(),
    payload
  );
};

export const Product_Delete = async (product_id, userToken) => {
  // return await axios.delete(
  //   `${base_url}api/v0/product/product_delete/${product_id}/`,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: "Token " + userToken,
  //     },
  //   }
  // );
  return await axiosInstance.delete(product_apis.product_delete(product_id), {
    useUserToken: true,
  });
};

export const All_Product_List = async (storeId) => {
  try {
    // const response = await axios.get(
    //   `${base_url}api/v0/store/store_product_list/${storeId}/?all=true`,
    //   {
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: Token,
    //     },
    //   }
    // );
    const response = await axiosInstance.get(
      product_apis.store_product_lists(storeId)
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const Sort_Product_List = async (storeId, sortValue) => {
  // return await axios.get(
  //   `${base_url}api/v0/store/store_product_list/${storeId}/?sort_value=${sortValue}`,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: Token,
  //     },
  //   }
  // );
  return await axiosInstance.get(
    product_apis.sort_store_product_lists(storeId, sortValue)
  );
};

const formatAuthHeader = (tok) => {
  if (!tok) return "";
  return tok.startsWith("Token ") ? tok : `Token ${tok}`;
};

export const Add_Bulk_Upload = async (
  userToken,
  storeId,
  file,
  zip,
  fileType
) => {
  let params = new FormData();
  zip && params.append("zip_media", zip);
  params.append("store_id", storeId);
  params.append("my_file", file);

  const cleanBase = (base_url || "").replace(/\/+$/, "");
  return await axios.post(
    `${cleanBase}/api/v1/store/product/bulk_upload/`,
    params,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: formatAuthHeader(userToken),
      },
    }
  );
};

export const Get_Bulk_Upload_Status = async (jobId, userToken) => {
  const cleanBase = (base_url || "").replace(/\/+$/, "");
  return await axios.get(
    `${cleanBase}/api/v1/store/product/bulk_upload/status/${jobId}/`,
    {
      headers: {
        Authorization: formatAuthHeader(userToken),
      },
    }
  );
};

export const Get_Bulk_Upload_History = async (params = {}, userToken) => {
  const cleanBase = (base_url || "").replace(/\/+$/, "");
  return await axios.get(
    `${cleanBase}/api/v1/store/product/bulk_upload/history/`,
    {
      params,
      headers: {
        Authorization: formatAuthHeader(userToken),
      },
    }
  );
};

export const Download_Bulk_Upload_Sample = async (fileType = "csv", userToken) => {
  const cleanBase = (base_url || "").replace(/\/+$/, "");
  return await axios.get(
    `${cleanBase}/api/v1/store/product/bulk_upload/`,
    {
      params: { file_type: fileType },
      responseType: "blob",
      headers: {
        Authorization: formatAuthHeader(userToken),
      },
    }
  );
};

export const Master_Product_Bulk_Upload = async (file, zip, userToken) => {
  let params = new FormData();
  zip && params.append("zip_media", zip);
  params.append("my_file", file);

  const cleanBase = (base_url || "").replace(/\/+$/, "");
  return await axios.post(
    `${cleanBase}/products/master-product-bulk-upload/`,
    params,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: userToken ? "Token " + userToken : "",
      },
    }
  );
};

export const Master_Product = async () => {
  // return await axios.get(`${base_url}api/v0/product/master-product/`, {
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: Token,
  //   },
  // });
  return await axiosInstance.get(product_apis.master_product, {
    useUserToken: false,
  });
};

export const Brought_Together = async (
  userLatitude,
  userLongitude,
  userPincode
) => {
  let params = {
    lat: userLatitude,
    long: userLongitude,
    pincode: userPincode,
  };

  // return await axios.post(
  //   `${base_url}api/v0/product/top-pics-products/`,
  //   params,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: Token,
  //     },
  //   }
  // );
  return await axiosInstance.post(product_apis.brought_together, params);
};

export const Unit_Of_Measure = async () => {
  // return await axios.get(`${base_url}api/v0/product/unit-of-measures/list/`, {
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: Token,
  //   },
  // });
  return await axiosInstance.get(product_apis.unit_of_measure);
};

export const Product_Ratings = async (id) => {
  // let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
  // return await axios.get(`${base_url}api/v0/product/product-rating/${id}/`, {
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: `Token ${userToken1}`,
  //   },
  // });
  return await axiosInstance.get(product_apis.product_ratings(id), {
    useUserToken: true,
  });
};

export const Product_Details_Rating = async (id) => {
  // return await axios.get(`${base_url}api/v0/product/product-rating/${id}/`, {
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: Token,
  //   },
  // });
  return await axiosInstance.get(product_apis.product_detail_ratings(id));
};

export const User_Product_Rating = async (payload, id) => {
  // let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
  // return await axios.post(
  //   `${base_url}api/v0/product/product-rating/${id}/`,
  //   payload,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Token ${userToken1}`,
  //     },
  //   }
  // );
  return await axiosInstance.post(
    product_apis.user_product_ratings(id),
    payload,
    { useUserToken: true }
  );
};

export const Store_Ratings = async (currentPage, limit) => {
  // let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
  // return await axios.get(
  //   `${base_url}api/v0/product/order-store-details/?page=${currentPage}&limit=${limit}`,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Token ${userToken1}`,
  //     },
  //   }
  // );
  return await axiosInstance.get(
    product_apis.store_ratings(currentPage, limit),
    { useUserToken: true }
  );
};

export const User_Last_Viewed = async (id) => {
  // let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
  const data = {
    product_id: id,
  };
  // return await axios.post(
  //   `${base_url}api/v0/product/last-viewed-products/`,
  //   data,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Token ${userToken1}`,
  //     },
  //   }
  // );
  return await axiosInstance.post(product_apis.last_viewed_products, data, {
    useUserToken: true,
  });
};

export const Store_Product_Details = async (
  storeId,
  currentPage,
  prodStatus,
) => {
  // return await axios.get(
  //   `${base_url}api/v0/store/store_product_list/${storeId}/?page=${currentPage}&prod_status=${prodStatus}`,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: Token,
  //     },
  //   }
  // );
  return await axiosInstance.get(
    product_apis.store_product_details(storeId, currentPage, prodStatus)
  );
};

export const Search_Store_Product = async (
  searchTerm,
  storeId,
  currentPage,
  text
) => {
  const data = {
    store_id: storeId,
    product_name: text ? text : searchTerm,
  };
  // return await axios.post(
  //   `${base_url}api/v0/store/search_product/${
  //     currentPage ? `?page=${currentPage}` : `?all=${true}`
  //   }`,
  //   data,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: Token,
  //     },
  //   }
  // );
  return await axiosInstance.post(
    product_apis.search_products_in_store(currentPage),
    data
  );
};

export const Search_Store_Product_Suggestions = async (
  searchTerm,
  storeId,
  isSearch
) => {
  const data = {
    store_id: storeId,
    product_name: searchTerm,
    is_search: isSearch,
  };
  // return await axios.post(`${base_url}api/v0/store/search_product/`, data, {
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: Token,
  //   },
  // });
  return await axiosInstance.post(
    product_apis.search_store_product_suggestions(),
    data
  );
};

export const Add_Product = async (
  data,
  productImage,
  additionalImage1,
  additionalImage2
) => {
  try {
    let params = new FormData();
    const storeId =
      data?.product_vendor_store ||
      data?.storeId ||
      localStorage.getItem(STORAGE_CONSTANTS.STORE_ID) ||
      localStorage.getItem("storeId");

    // Append form data fields to the FormData object
    params.append("product_name", data?.productName ?? null);
    params.append("product_description", data?.description ?? null);
    if (storeId) {
      params.append("product_vendor_store", storeId);
    }
    productImage && params.append("product_image", productImage);
    additionalImage1 && params.append("additional_image_1", additionalImage1);
    additionalImage2 && params.append("additional_image_2", additionalImage2);
    params.append("product_subcategory", data?.category);
    params.append("pieces", 0);
    params.append("available", data?.inventory);
    params.append("unit_measure", data?.unitOfMeasure);
    params.append("weight", data?.variants ?? null);
    params.append("price", parseInt(data?.priceInNepali));
    params.append("usd_price", parseInt(data?.usd_price ?? 0));
    params.append("nepali_name", data?.productNameInNepali ?? null);
    params.append("nepali_description", data?.descriptionInNepali ?? null);
    params.append("minimum_qty", parseInt(data?.minQuantity ?? null));
    params.append("maximum_qty", data?.maxQuantity ?? null);
    params.append("sku", data?.sku ?? null);
    params.append("brand", data?.brand ?? null);
    params.append("threshold_limit", data?.threshold_limit ?? null);

    // Use axiosInstance and pass useUserToken: true to use userToken from localStorage
    return await axiosInstance.post(product_apis.add_product(), params, {
      useUserToken: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    throw error;

  }
};

export const Edit_Product = async (
  userToken,
  data,
  productImage,
  product_id,
  additionalImage1,
  additionalImage2
) => {
  try {
    let params = new FormData();
    params.append("product_name", data.productName);
    params.append("product_description", data.description);
    productImage && params.append("product_image", productImage);
    additionalImage1 && params.append("additional_image_1", additionalImage1);
    additionalImage2 && params.append("additional_image_2", additionalImage2);
    params.append("product_subcategory", parseInt(data.category));
    params.append("pieces", parseInt(data.minQuantity));
    params.append("available", parseInt(data.inventory));
    params.append("unit_measure", data.unitOfMeasure);
    params.append("weight", parseInt(data.variants));
    params.append("weight", parseInt(0));
    params.append("height", parseInt(0));
    params.append("price", parseInt(data.priceInNepali));
    params.append("usd_price", parseInt(data.price) || 0);
    // params.append("variants", data.variants);
    params.append("variants", []);
    params.append("nepali_name", data.productNameInNepali);
    params.append("nepali_description", data.descriptionInNepali);
    params.append("minimum_qty", parseInt(data?.minQuantity));
    params.append("maximum_qty", data?.maxQuantity ?? null);
    params.append("sku", data?.sku ?? null);
    params.append("brand", data?.brand ?? null);
    params.append("threshold_limit", data?.threshold_limit ?? null);

    // Use axiosInstance and pass useUserToken: true to use userToken from localStorage
    return await axiosInstance.put(
      product_apis.edit_product(product_id),
      params,
      {
        useUserToken: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  } catch (error) {
    throw error;
  }
};

export const Products_for_Review = async (currentPage, limit) => {
  try {
    return await axiosInstance.get(
      product_apis.product_for_review(currentPage, limit),
      {
        useUserToken: true,
      }
    );
  } catch (error) {
    throw error;
  }
};
export const Last_Viewed = async () => {
  try {
    return await axiosInstance.get(product_apis.last_viewed(), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};
